import { createGlobalStyle } from 'styled-components';
import { COLORS } from '@/theme';

export const PopoverOverlayGlobalStyles = createGlobalStyle`
  .cc-popover-overlay {
    .ant-popover-inner {
      padding: 1rem;
      border-radius: 0.125rem;
      box-shadow: 0 0 0 1px ${COLORS.GRAY_LIGHT};
    }
    .ant-popover-arrow::after {
      border-radius: 0.125rem;
      background-color: ${COLORS.WHITE};
      box-shadow: 0 0 0 1px ${COLORS.GRAY_LIGHT};
    }
  }
`;
